import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Camera, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Coach/admin: attach training photos to a session — parents see them on their dashboard. */
export const SessionPhotoUploadButton = ({ sessionId, label = "Photos" }) => {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const upload = async (fileList) => {
    if (!fileList?.length) return;
    const form = new FormData();
    Array.from(fileList).forEach((f) => form.append("files", f));
    form.append("session_date", new Date().toISOString().slice(0, 10));
    setUploading(true);
    try {
      const res = await axios.post(`${API}/media/session-photos/${sessionId}`, form);
      toast.success(`${res.data.files?.length || 0} photo(s) shared with parents`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not upload the photos");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        multiple
        className="hidden"
        onChange={(e) => upload(e.target.files)}
        data-testid={`session-photo-input-${sessionId}`}
      />
      <Button
        size="sm"
        variant="outline"
        className="text-xs border-slate-600"
        onClick={() => inputRef.current?.click()}
        disabled={uploading}
        data-testid={`session-photo-upload-${sessionId}`}
      >
        {uploading ? <Loader2 className="w-3 h-3 mr-1 animate-spin" /> : <Camera className="w-3 h-3 mr-1" />}
        {label}
      </Button>
    </>
  );
};

export default SessionPhotoUploadButton;
